import Cotizar from './Cotizar';
import CotizarConfirmation from './CotizarConfirmacion';

export { CotizarConfirmation };
export default Cotizar;
